import { uploadApi } from '../../../apis/uploadApi';
import Api from '../../../apis/Api';
import Vue from 'vue';
import i18n from '../../../plugins/i18n';

export const LoadStatus = {
  initial: 'initial',
  loading: 'loading',
  loaded: 'loaded',
  retry: 'retry',
  error: 'error'
};

export const PairingStatus = {
  initial: 'initial',
  pairing: 'pairing',
  paired: 'paired',
  error: 'error'
};

export const ResourceTypes = {
  RGB: 'RGB',
  IR: 'IR',
  CSV: 'CSV',
  JSON: 'JSON'
};

const state = {
  pairingStatus: {}, // {reportId: PairingStatus}
  pairingResults: {} // {reportId: ImageParingResult}
};

const getters = {
  pairingStatus: (state) => (reportId) =>
    state.pairingStatus[reportId] || PairingStatus.initial,
  pairingResults: (state) => (reportId) =>
    state.pairingResults[reportId] || null
};

const mutations = {
  RESET_PAIRING(state) {
    state.pairingStatus = {};
    state.pairingResults = {};
  },
  SET_PAIRING_STATUS(state, { reportId, status }) {
    console.log('SET_PAIRING_STATUS', state.pairingStatus[reportId]);
    Vue.set(state.pairingStatus, reportId, status);
  },
  SET_PAIRING_RESULTS(state, { reportId, results }) {
    Vue.set(state.pairingResults, reportId, results);
  }
};

const actions = {
  async pairingFiles({ dispatch, commit }, { reportId }) {
    try {
      await commit('SET_PAIRING_STATUS', {
        reportId,
        status: PairingStatus.pairing
      });
      const response = await Api.create(
        `/examine-report/${reportId}/images/relation`
      );
      if (response.data?.result === 'S') {
        commit('SET_PAIRING_STATUS', {
          reportId,
          status: PairingStatus.paired
        });
        
        // 페어링 결과 저장 (ServiceResponse의 content 필드에서 가져옴)
        const pairingResult = response.data?.content || response.data?.data;
        if (pairingResult) {
          commit('SET_PAIRING_RESULTS', {
            reportId,
            results: pairingResult
          });
          
          // 페어링 결과 상세 정보 표시
          const resultMessage =
            `${i18n.t('pairing.resultTitle')}\n\n` +
            `${i18n.t('pairing.uploadedSection')}\n` +
            `${i18n.t('pairing.rgbImageCount', { count: pairingResult.rgbImageCount || 0 })}\n` +
            `${i18n.t('pairing.thermalImageCount', { count: pairingResult.thermalImageCount || 0 })}\n` +
            `${i18n.t('pairing.thermalDataCount', { count: pairingResult.thermalDataCount || 0 })}\n\n` +
            `${i18n.t('pairing.pairingResultSection')}\n` +
            `${i18n.t('pairing.thermalRgbPairRate', { paired: pairingResult.thermalRgbPairedCount || 0, total: pairingResult.thermalImageCount || 0 })}\n` +
            `${i18n.t('pairing.thermalDataPairRate', { paired: pairingResult.thermalDataPairedCount || 0, total: pairingResult.thermalImageCount || 0 })}`;
          alert(resultMessage);
        } else {
          alert(i18n.t('pairing.success'));
        }
      } else throw new Error(response.data?.resultDesc);
    } catch (error) {
      console.error('테스트 Pairing files failed:', error);
      commit('SET_PAIRING_STATUS', { reportId, status: PairingStatus.error });
      alert(i18n.t('pairing.error.system'));
    } finally {
      setTimeout(() => {
        // dispatch("uploadsnackbar/hideSnackbar", null, { root: true });
      }, 3000);
    }
  },
  async uploadJSONFiles({ dispatch, commit }, { reportId, files }) {
    const formData = new FormData();
    files.forEach((file) => formData.append('attrZipFile', file));
    try {
      await uploadApi.post(
        `/api/examine-report/${reportId}/images/attributes`,
        formData
      );
    } catch (error) {
      console.log('error:', error);
      throw new Error(error.message);
    }
  },
  resetPairing({ commit }) {
    commit('RESET_PAIRING');
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
